import { type PropsWithChildren, useEffect } from "react";
import { type SubmitHandler, useForm } from "react-hook-form";

import type { Supplier } from "@/apis/gql/types";
import { AutoSaveForm } from "@/components/shared/form/form-auto-save";
import { SupplierDropdownInput } from "@/components/shared/form/supplier-dropdown-input";
import { Form } from "@/components/ui/form";

type Props = PropsWithChildren<{
  onSubmit: SubmitHandler<any>;
  values?: any;
}>;

const FiltersRoot = ({ children, onSubmit, values }: Props) => {
  const form = useForm({});

  useEffect(() => {
    Object.keys(form.getValues()).forEach((key) => {
      form.setValue(key, values[key]);
    });
  }, [values, form.reset]);

  const handleSubmit = (data: any) => {
    onSubmit(data);
  };

  return (
    <Form {...form}>
      {children}
      <AutoSaveForm onSubmit={handleSubmit} debounceTime={10} />
    </Form>
  );
};

type SupplierFilterProps = {
  name?: string;
  options: Supplier[];
  placeholder?: string;
  label?: string;
  createSupplier?: boolean;
  type: "creditor" | "debtor";
};

const SupplierFilter = ({
  name = "supplierId",
  options,
  placeholder,
  label,
  createSupplier,
  type,
}: SupplierFilterProps) => {
  return (
    <SupplierDropdownInput
      name={name}
      options={options}
      placeholder={placeholder}
      label={label}
      enableClear={false}
      createSupplier={createSupplier}
      type={type}
    />
  );
};

export default FiltersRoot;

export { SupplierFilter };
